import { RouterItem } from './interfaces/routerItems';

export const ROUTER_ITEMS_FOR_DEVELOPMENT: ReadonlyArray<Readonly<RouterItem>> = [
  { name: 'サイドバー:ダッシュボード', longName: 'サイドバー:ダッシュボード', icon: 'dashboard', to: '/inventory-dashboard' },
  {
    name: '登録',
    longName: '登録/入力',
    icon: 'sidebar-logo-1',
    to: '/input-data',
    expandChildren: [
      {
        name: 'データ入力',
        to: '/input-data',
      },
      {
        name: '取引削除',
        to: '/business-removal',
      },
      {
        name: '取引一括編集',
        to: '/business-edit/bulk',
      },
      {
        name: '選択肢編集',
        to: '/business-edit/master',
      },
    ],
  },
  {
    name: 'ショート管理表',
    longName: '管理表',
    icon: 'sidebar-logo-2',
    to: '/inventory-control',
    expandChildren: [
      {
        name: 'サイドバー:在庫管理',
        to: '/inventory-control',
      },
      {
        name: 'サイドバー:発注管理',
        to: '/business',
      },
      {
        name: '未管理',
        to: '/unmanaged-business',
      },
    ],
  },
  {
    name: '発注',
    icon: 'sidebar-logo-3',
    to: '/firm-order',
    expandChildren: [
      {
        name: '発注一覧',
        to: '/firm-order',
      },
      {
        name: '発注カレンダー',
        to: '/order-calendar',
      },
      {
        name: '発注出力',
        to: '/not-exported-order',
      },
      {
        name: '未照合・差異',
        to: '/unmatched-orders',
      },
    ],
  },
  {
    name: '内示(サイドバー)',
    icon: 'sidebar-logo-4',
    // TODO: ひとまず全取引ページに遷移させている
    // to: '/supplier',
    to: '/supplier/all-businesses',
    expandChildren: [
      {
        name: '客先内示',
        to: '/customer',
      },
      {
        name: '仕入先内示',
        // TODO: ひとまず全取引ページに遷移させている
        // to: '/supplier',
        to: '/supplier/all-businesses',
      },
    ],
  },
  {
    name: `カレンダー`,
    longName: '稼働日カレンダー',
    icon: 'sidebar-logo-5',
    to: '/calendar',
  },
  {
    name: '設定',
    icon: 'sidebar-logo-6',
    to: '/settings',
  },
  {
    name: 'ゴミ箱',
    icon: 'sidebar-logo-7',
    to: '/trash-bin',
  },
];

export const ROUTER_ITEMS_FOR_PRODUCTION: ReadonlyArray<Readonly<RouterItem>> = [
  { name: 'サイドバー:ダッシュボード', longName: 'サイドバー:ダッシュボード', icon: 'dashboard', to: '/inventory-dashboard' },
  {
    name: '登録',
    longName: '登録/入力',
    icon: 'sidebar-logo-1',
    to: '/input-data',
    expandChildren: [
      {
        name: 'データ入力',
        to: '/input-data',
      },
      {
        name: '取引削除',
        to: '/business-removal',
      },
      {
        name: '取引一括編集',
        to: '/business-edit/bulk',
      },
      {
        name: '選択肢編集',
        to: '/business-edit/master',
      },
    ],
  },
  {
    name: 'ショート管理表',
    longName: '管理表',
    icon: 'sidebar-logo-2',
    to: '/inventory-control',
    expandChildren: [
      {
        name: 'サイドバー:在庫管理',
        to: '/inventory-control',
      },
      {
        name: 'サイドバー:発注管理',
        to: '/business',
      },
      {
        name: '未管理',
        to: '/unmanaged-business',
      },
    ],
  },
  {
    name: '発注',
    icon: 'sidebar-logo-3',
    to: '/firm-order',
    expandChildren: [
      {
        name: '発注一覧',
        to: '/firm-order',
      },
      {
        name: '発注カレンダー',
        to: '/order-calendar',
      },
      {
        name: '発注出力',
        to: '/not-exported-order',
      },
      {
        name: '未照合・差異',
        to: '/unmatched-orders',
      },
    ],
  },
  {
    name: '内示(サイドバー)',
    icon: 'sidebar-logo-4',
    // TODO: ひとまず全取引ページに遷移させている
    // to: '/supplier',
    to: '/supplier/all-businesses',
    expandChildren: [
      {
        name: '客先内示',
        to: '/customer',
      },
      {
        name: '仕入先内示',
        // TODO: ひとまず全取引ページに遷移させている
        // to: '/supplier',
        to: '/supplier/all-businesses',
      },
    ],
  },
  {
    name: `カレンダー`,
    longName: '稼働日カレンダー',
    icon: 'sidebar-logo-5',
    to: '/calendar',
  },
  {
    name: '設定',
    icon: 'sidebar-logo-6',
    to: '/settings',
  },
  {
    name: 'ゴミ箱',
    icon: 'sidebar-logo-7',
    to: '/trash-bin',
  },
];
